<div class="container mb-5">
  <div class="row">
    <div class="col-sm-2">
      <app-dashmenu></app-dashmenu>
    </div>
    <div class="col-sm-10">
      <div class="card p-2">

        <!-- <button class="btn btn-primary" (click)="openPDF()" type="button" name="button" style="width:100%;"><i class="fa fa-file-pdf-o"></i> Generate PDF</button> -->

        <div id="facture" class="container mt-5">
          <!-- <div class="row mb-5">
            <div class="col-6">
              <h4 class="titreFacture">Commande</h4>
              <h5 class="nomBuyer">Nom de l'acheteur</h5>
              <p class="adresse">Adresse de facturation</p>
            </div>
            <div class="col-6 mt-3 text-end">
              <p class="p-0 m-0"><strong>Commande Num° :</strong> 1711547</p>
              <p class="p-0 m-0"><strong>Date commande :</strong> 17/06/2022</p>
              <p class="p-0 m-0"><strong>Etat de la facture :</strong> En cours</p>
            </div>
            </div> -->
          <div class="row mb-5">
            <div class="table-responsive mt-5">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">Produit</th>
                    <th scope="col">Désignation</th>
                    <th scope="col">Quantités commandées</th>
                    <th scope="col">Quantités livrées</th>
                    <th scope="col">Quantités facturées</th>
                    <th scope="col">Etat de facturation</th>
                    <th scope="col">Prix</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let produit of produits" >
                    <td>{{produit.ITMREF}}</td>
                    <td>{{produit.ITMDES}}</td>
                    <td>{{produit.QTY}}</td>
                    <td>{{produit.DLVQTY}}</td>
                    <td>{{produit.INVQTY }}</td>
                    <td>{{produit.SOQSTA_LBL}}</td>
                    <td>{{produit.NETPRI}}</td>
                  </tr>
                  <tr>
                    <td colspan="5"></td>
                    <td><strong>Montant Total TTC</strong></td>
                    <td><strong>{{total}} MAD</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
